export class Typearticle {
  id: number;
  libelle: string;
}

